import { createSlice } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { finalMarkLogBookService } from "../services/lessonService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "./utils";

const get = createCustomAsyncThunk(
    "finalMarkLogBook/get",
    async params => await finalMarkLogBookService.get(params)
)

const post = createCustomAsyncThunk(
    "finalMarkLogBook/post",
    async data => await finalMarkLogBookService.post(data)
)

const patch = createCustomAsyncThunk(
    "finalMarkLogBook/patch",
    async data => await finalMarkLogBookService.patch(data)
)

const finalMarkLogBookSlice = createSlice({
    name: "finalMarkLogBook",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        isUpdating: false,
        error: null,
    }),
    reducers: {
        reset: state => { defaultEntityAdapter.removeAll(state) }
    },
    extraReducers: builder => {
        builder
            .addCase(get.pending, state => { state.isLoading = true })
            .addCase(get.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(get.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(post.pending, state => { state.isUpdating = true })
            .addCase(post.fulfilled, (state, action) => {
                defaultEntityAdapter.upsertOne(state, { id: action.payload.student, final_mark: action.payload })
                state.isUpdating = false
            })
            .addCase(post.rejected, (state, action) => {
                state.error = action.error
                state.isUpdating = false
            })

            .addCase(patch.pending, state => { state.isUpdating = true })
            .addCase(patch.fulfilled, (state, action) => {
                defaultEntityAdapter.upsertOne(state, { id: action.payload.student, final_mark: action.payload })
                state.isUpdating = false
            })
            .addCase(patch.rejected, (state, action) => {
                state.error = action.error
                state.isUpdating = false
            })
    }
})

export default finalMarkLogBookSlice.reducer

const selectors = defaultEntityAdapter.getSelectors(x => x.finalMarkLogBook)

export const useFinalMarkLogBook = (group_id, subject_id, study_year) => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (group_id && subject_id && study_year) {
            dispatch(get({ group_id, subject_id, study_year }))
        }
        return () => dispatch(finalMarkLogBookSlice.actions.reset())
    }, [dispatch, group_id, subject_id, study_year])

    const finalMarkLogBook = useSelector(selectors.selectAll)
    const finalMarkLogBookIsLoading = useSelector(x => x.finalMarkLogBook.isLoading)
    const finalMarkLogBookIsUpdating = useSelector(x => x.finalMarkLogBook.isLoading)

    const handleCreateFinalMark = data => dispatch(post(data)).unwrap().catch(e => { console.error(e) })
    const handleUpdateFinalMark = data => dispatch(patch(data)).unwrap().catch(e => { console.error(e) })

    return { finalMarkLogBook, finalMarkLogBookIsLoading, finalMarkLogBookIsUpdating, handleCreateFinalMark, handleUpdateFinalMark }
}